export const filterHoverClasses = (classes: string): string => {
  return classes
    .split(" ")
    .filter((cls) => !cls.startsWith("hover:"))
    .join(" ");
};
